import {Device, GPS} from "app/lib/api";

export class DeviceGPS {
  constructor(public device: Device, public gps: GPS) {

  }
}
